module.exports = __webpack_public_path__ + "static/media/pflogo.9a77ed2d.webp";